<img obgImageContent="general.browser-not-supported" />
<h1 class="obg-browser-not-supported-header">{{ "not-supported.browser.title" | translate }}</h1>
<p>{{ "not-supported.browser.message" | translate }}</p>
<div class="obg-browser-not-supported-images">
	<div *ngFor="let browser of ['chrome', 'firefox', 'edge', 'safari']; trackBy: trackBybrowser">
		<img [obgImageContent]="getBrowserSpecificImageKey(browser)" />
		<h2
			class="obg-browser-not-supported-browser-header"
			[innerHTML]="'general.browser-download-' + browser | translate"
		></h2>
		<p [innerHTML]="'general.browser-' + browser + '-os' | translate"></p>
	</div>
</div>
